export class Customer {
    CustomerID: string;
    CustomerName: string;

	constructor(CustomerID: string, CustomerName: string) {
		this.CustomerID = CustomerID;
		this.CustomerName = CustomerName;
	}
}
